import React, { useState, useEffect } from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import Papa from 'papaparse';
import './PriceHistoryChart.css'; // Ensure this import is present

const PriceHistoryChart = ({ csvFilePath }) => {
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [error, setError] = useState(null);
  const [filter, setFilter] = useState('all');

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(csvFilePath);
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const reader = response.body.getReader();
        const result = await reader.read(); // raw array
        const decoder = new TextDecoder('utf-8');
        const csv = decoder.decode(result.value); // the csv text
        console.log('CSV Data:', csv);
        const results = Papa.parse(csv, { header: true, skipEmptyLines: true });
        console.log('Parsed Results:', results);
        const formattedData = results.data.map(item => ({
          date: item.date,
          price: parseFloat(item.price)
        })).reverse(); // Reverse the data array
        console.log('Formatted Data:', formattedData); // Log the parsed data
        setData(formattedData);
        setFilteredData(formattedData);
      } catch (err) {
        console.error('Error fetching or parsing data:', err);
        setError('Error fetching or parsing data');
      }
    };

    fetchData();
  }, [csvFilePath]);

  const handleFilterChange = (filter) => {
    setFilter(filter);
    const now = new Date();
    let filtered = data;

    if (filter === '1year') {
      const oneYearAgo = new Date(now.setFullYear(now.getFullYear() - 1));
      filtered = data.filter(item => new Date(item.date) >= oneYearAgo);
    } else if (filter === '5years') {
      const fiveYearsAgo = new Date(now.setFullYear(now.getFullYear() - 5));
      filtered = data.filter(item => new Date(item.date) >= fiveYearsAgo);
    } else if (filter === '10years') {
      const tenYearsAgo = new Date(now.setFullYear(now.getFullYear() - 10));
      filtered = data.filter(item => new Date(item.date) >= tenYearsAgo);
    }

    setFilteredData(filtered);
  };

  return (
    <div className="chart-container">
      {error && <p>{error}</p>}
      {!error && data.length === 0 && <p>Loading data...</p>}
      {!error && data.length > 0 && (
        <>
          <div className="filter-buttons">
            <button onClick={() => handleFilterChange('1year')} className={filter === '1year' ? 'active' : ''}>1 Year</button>
            <button onClick={() => handleFilterChange('5years')} className={filter === '5years' ? 'active' : ''}>5 Years</button>
            <button onClick={() => handleFilterChange('10years')} className={filter === '10years' ? 'active' : ''}>10 Years</button>
            <button onClick={() => handleFilterChange('all')} className={filter === 'all' ? 'active' : ''}>All Time</button>
          </div>
          <ResponsiveContainer width="98%" height={400}>
            <LineChart data={filteredData}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="date" />
              <YAxis />
              <Tooltip />
              <Line type="monotone" dataKey="price" stroke="#8884d8" dot={false} />
            </LineChart>
          </ResponsiveContainer>
        </>
      )}
    </div>
  );
};

export default PriceHistoryChart;